import React from 'react';
import { HuchaValues } from '../../models/hucha-values';
import { HuchaBonusPdf } from './hucha-bonus-pdf';
import { RenovadoresPlus15BonusPdf } from './renovadores-plus15-bonus-pdf';
import { RenovadoresStandardBonusPdf } from './renovadores-standard-bonus-pdf';

export const HuchaPDFContent = ({
	targetRef,
	huchaValues,
}: {
	targetRef: React.RefObject<HTMLDivElement>;
	huchaValues: HuchaValues | null;
}) => {
	const layerContent = () => {
		if (!huchaValues?.isRenovador) {
			return <HuchaBonusPdf huchaValues={huchaValues} />;
		}

		if (huchaValues.renovadorTier === 'standard') {
			return <RenovadoresStandardBonusPdf huchaValues={huchaValues} />;
		}

		if (huchaValues.renovadorTier === 'plus15') {
			return <RenovadoresPlus15BonusPdf huchaValues={huchaValues} />;
		}
		return null;
	};

	return (
		<div
			ref={targetRef}
			style={{
				position: 'absolute',
				left: '-9999px',
				width: '1024px',
				overflow: 'visible',
				pageBreakInside: 'avoid',
				breakInside: 'avoid',
			}}
		>
			{layerContent()}
		</div>
	);
};
